import { useMutation } from '@apollo/client'
import { useToast } from 'components/Dashboard/Toast'
import { Modal2 } from 'components/Modal'
import SubmitButton from 'components/SubmitButton'
import TextInput from 'components/TextInput'
import { Form, Formik } from 'formik'
import { changeKitStatusMutation } from './DeactivateKitModal'
import { ChangeKitStatusMutation, ChangeKitStatusMutationVariables } from './__generated__/ChangeKitStatusMutation'

interface ReactivateKitModalProps {
  kitId: string
  onRequestClose: () => void
}

const ReactivateKitModal = ({ kitId, onRequestClose }: ReactivateKitModalProps) => {
  const [changeKitStatus] = useMutation<ChangeKitStatusMutation, ChangeKitStatusMutationVariables>(
    changeKitStatusMutation
  )

  const { addToast } = useToast()

  return (
    <Modal2 isOpen onRequestClose={onRequestClose} header="Reactivate Kit">
      <Formik
        initialValues={{ zdRef: '', reason: '' }}
        onSubmit={async (values, { setStatus }) => {
          try {
            const resp = await changeKitStatus({
              variables: {
                input: {
                  kitId,
                  status: 'CREATED',
                  context: 'Reactivate Kit Modal',
                  reason: values.reason,
                  zdRef: values.zdRef,
                },
              },
            })

            if (!resp.data.changeKitStatus.success) {
              throw new Error(resp.data.changeKitStatus.message || 'Something went wrong')
            }

            onRequestClose()
            addToast({
              messageType: 'success',
              title: 'Reactivated',
              content: <>Kit reactivated</>,
              timeout: 5000,
            })
          } catch (err) {
            setStatus({ error: err.message })
          }
        }}
      >
        {({ isSubmitting, status }) => (
          <Form>
            <TextInput name="reason" label="Reason for reactivating kit" />
            <TextInput name="zdRef" label="Zendesk ticket no (if applicable)" />

            <div className="buttons is-right mt-5">
              <SubmitButton className="is-primary" submitting={isSubmitting} disabled={isSubmitting}>
                Reactivate Kit
              </SubmitButton>
            </div>
            {status?.error && (
              <article className="message is-danger">
                <div className="message-body">Failed: {status.error}</div>
              </article>
            )}
          </Form>
        )}
      </Formik>
    </Modal2>
  )
}

export default ReactivateKitModal
